import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var client = "Client/";
var Loan = "Loan/";
var familyTagging = "familytagging/";
export var ElasticSearch = "ElasticSearch/";
var common = "Common/";
var clientUrlConfig = {
    ValidateParam: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ValidateParam",
    ValidateparamForExchange: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ValidateparamForExchange",
    HomogenousGetTierCurrentStatus: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "HomogenousGetTierCurrentStatus",
    search: URLConfig.config.apiBase + microService.dashboardService + client,
    familySearch: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "familytagging/Search",
    headerAccCode: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "AccountCodes",
    clientOverview: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Overview",
    headerAUM: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "AUM/Summary",
    clientMultipleContact: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "MultipleContacts",
    clientMCAssess: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "MultipleContacts/Access",
    passwordResentHistory: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "GetPassWordResetHistory",
    ownerHistory: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "OwnerHistory",
    dpDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DpDetails",
    bankDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "BankDetails",
    clientPassthrough: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Passthrough",
    familyTagging: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "familytagging",
    deleteFamileMember: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DeleteMember",
    historicalView: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Loan/Historical",
    platformsDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "PlatformDetails",
    consentDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ConsentDetails",
    owners: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Owners",
    RevAUMData: URLConfig.config.apiBase + microService.dashboardService + client + "AUM",
    activeLoans: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        Loan +
        "Active",
    activeLoanDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        Loan +
        "Details",
    upiDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "UpiDDetails",
    loaDetails: URLConfig.config.apiBase + microService.dashboardService + client + "LOA",
    npsDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "NpsDetails",
    eligibilityDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Eligibility",
    pastIntractionDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "PastInteraction",
    saveThirdPartyPOADetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ThirdPartyPOA",
    getThirdPartyPOADetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "GetThirdPartyPOAData",
    thirdPartyPOADetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ClientDetailsPOAData",
    clientLifeCycleDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "LifeCycle",
    clientDpLedgerGetCatogeryDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DpLedger/Category",
    clientDpLedgerDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DpLedger",
    adbSchemeWiseDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Offer/AdbSubscriptionDetails",
    backOfficeUrl: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "BackOffice/Passthrough",
    mfRagistrationBook: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "MfRegistrationBook",
    mfOrderBook: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "MfOrderBook",
    dpcDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DpcDetails",
    brokVolDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Broking/Volume",
    brokingPlan: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Broking/Plan",
    payingDetails: URLConfig.config.apiBase + microService.dashboardService + client + "Payin",
    aumSummaryDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "AumSummaryDetails",
    fnoMarginDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "FnoMargin",
    revenueFnoMargin: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Revenue/FNOMargin",
    adbRenewel: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Adb/RenewalDetails",
    adbCurrentPlans: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Adb/CurrplanDetail",
    newCurrentPlan: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Adb/CurrentPlan",
    adbDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Adb/SubscriptionDetails",
    newAdbDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Broking_GetADB_SUB_Detail",
    adbSchemeWise: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Adb/SchemeOffer",
    revenueInsuranceData: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Insurance",
    adbActiveOffer: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Offer/Active/AdbSubscription",
    adbFutureOffer: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Offer/Future/AdbSubscription",
    adbExpiredOffer: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Offer/Expired/AdbSubscription",
    FamilyDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "FamilyDetails",
    DeleteFamilyMemeber: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DeleteMember",
    paylinkReportsDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Payin/Report",
    generatePaymentLink: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Payin/GenerateLink",
    getCountryCodeMasterDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "GetCountryCode",
    killPaymentLink: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Payin/DisableLink",
    getMortageDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Mortagage",
    masterRelation: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Master/Relation",
    FamilyMemberDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "FamilyDetails",
    addeditUPIDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "UPIDetails",
    eMandateDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "EMandate",
    getPaylinkReport: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "GetPaylinkReport",
    MandateDetail: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "MandateDetail",
    requestMandate: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "RequestMandate",
    mandateEmail: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "MandateEmail",
    GetValidateBank: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "GetValidateBank",
    deleteLOA: URLConfig.config.apiBase + microService.dashboardService + client + "LOA",
    pastInteractionDownload: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "PastInteractionDownload",
    getPaylinkScenarioDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Payin/Scenario",
    getDataFromQRC: URLConfig.config.apiBase + microService.dashboardService + client + "QRC",
    getIncomeDeclarationGetClientType: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ClientType",
    getIncomeDeclarationGetNonClientType: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "NonClientType",
    getPlatformSMTFAcceptReject: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ConsentSMTF",
    updatePlatformSMTFReq: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "MTFConsent",
    getPlatformBSERequest: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "BSEConsent",
    getBankDetailsMandateForms: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "MandateBankDetails",
    getBankBranchDetailsMandateForms: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "BranchDetails",
    postPlatformBSERequestAccept: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "BSEMFConsent",
    postPlatformBSEUpload: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "BSEMFConsentUpload",
    postPlatformReactivationLink: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "SMTFStatus",
    mandateSampleFile: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "SampleFile",
    getRazorPayAccountDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "RazDetails",
    getRazorPayTransDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "RazDetailsTrans",
    sendLoaDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "sendloadetails",
    saveLoaDetails: URLConfig.config.apiBase + microService.dashboardService + client + "loa",
    viewIncomeDeclaration: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "QRCView",
    viewIncomeDeclarationSR: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "QRCIncomeSR",
    getIncomeRange: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "IncomeRange",
    brokingAccountDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Broking/Account",
    getRefIdDetails: URLConfig.config.apiBase + microService.dashboardService + client + "RefID",
    downloadPrismReports: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Prism/Download",
    getPartnerStatus: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Partner",
    getDPDetailsbyDPId: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DpDetail",
    sendOTP: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "SendOTP",
    verifyOTP: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "VerifyOTP",
    saveIncomeDeclaration: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "IncomeDeclaration",
    PostIncomeClientValidation: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "clientValidation",
    QRCDocDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "QRC/QRCDocDetails",
    PostIncomeServiceRequest: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "QRC/ServiceRequest",
    subTypeMaster: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "SubTypeMaster",
    planOffer: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Broking/Plan",
    futureOffer: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "FutureOffer",
    expiredOffer: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ExpiredOffer",
    activeOffer: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ActiveOffer",
    getExceptionlsin: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ISINList",
    getExceptionData: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ExceptionData",
    getExceptionSegment: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ExceptionSegment",
    saveExceptionHaircut: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ExceptionHaircut",
    mfRagistrationBookAccode: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "MFSIPSub",
    dncstd: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DNCSTDResponse",
    dncPendingSts: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DncPendingStatus",
    dncData: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DNCData",
    poaEdis: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "POAData",
    fnoAvailableCashData: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "CashEquivalentDetailsReport",
    ckycDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "CKYCDetails",
    saveCkycDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "SaveCKYCdetails",
    deletePoa: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ThirdPartyPOAData",
    downloadKYCData: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "KYCDownload",
    downloadCMLReports: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "CMLReport",
    clientBrokCommDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "ClientBrokCommDetails_His",
    clientSubFeeDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "GetSubFeeClientBrokerageCommodityDetails_DayWiseHistory",
    getAumInsurance: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "GetAUMInsurance",
    getClientTierListUrl: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "HomogenousTierList",
    getClientTierReasonListUrl: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "HomogenousReasonList",
    saveHomogenousPostRMFeedbackData: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "HomogenousPostRMFeedbackData",
    getTaskDetailsByTaskId: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "TaskDetailsByTaskId",
    getFnoConsentDetails: URLConfig.config.apiBase + microService.dashboardService + "FNO/FNOConsent",
    getDpNomineeDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "DpNomineeDetails",
    getfamilyDetails: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "getfamilyDetails",
    getFamilyRelations: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "familyrelations",
    getFamily: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "getfamily",
    getFamilyMembers: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "getfamilymembers",
    createFamily: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "createfamily",
    updateFamilyName: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "updateFamilyName",
    createFamilyMember: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "createfamilymember",
    createFamilyMemberMultiple: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "createfamilymembermultiple",
    removeFamily: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "removefamily",
    removeFamilyMember: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "removefamilymember",
    clientFamilySearch: URLConfig.config.apiBase +
        microService.dashboardService +
        client +
        "Search",
    exitFamily: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "exitfamily",
    consentCancel: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "consentcancel",
    consentResend: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "consentresend",
    isMyClient: URLConfig.config.apiBase +
        microService.dashboardService +
        familyTagging +
        "isMyClient",
    searchClientsByRmWithOwnClient: "".concat(URLConfig.config.apiBaseElasticSearch).concat(microService.masterSevice).concat(ElasticSearch, "uccclient"),
    validateClient: "".concat(URLConfig.config.apiBaseElasticSearch).concat(microService.masterSevice).concat(common, "validateclient"),
    recentClientSearchGet: "".concat(URLConfig.config.apiBaseElasticSearch).concat(microService.masterSevice).concat(common, "recentclientsearchget"),
    recentClientSearchSave: "".concat(URLConfig.config.apiBaseElasticSearch).concat(microService.masterSevice).concat(common, "recentclientsearchsave"),
};
export default clientUrlConfig;
